(async () => {
  const {
    updateURLParams,
    historyPush,
    parseHTML
  } = await import(window.theme.modules.utils);
  
  const isEqual = (arr1, arr2) => arr1.toString() === arr2.toString();
  const parseJSON = (el) => JSON.parse(el.textContent)
  const optionValueName = (value) => value?.name || value;
  const findOptionInput = (root, name, value) => {
    return Array.from(root.querySelectorAll('input[name]')).find((input) => input.name === name && input.value === value);
  };
  const baseComponent = await import(window.theme.modules.baseComponent);

  if (customElements.get('product-option-picker')) return;

  customElements.define('product-option-picker', class extends baseComponent.default {
    elements = {
      variantsJSON: '[data-variants-json]',
      optionsJSON: '[data-options-with-values]'
    };
    
    render() {
      this.isProductPage = this.getAttribute('page-type') === 'product';
      this.variantsData = parseJSON(this.$variantsJSON);
      this.optionsData = parseJSON(this.$optionsJSON);
      this._getDefaultVariant();
      this._checkUnavailable();
      this.addEventListener('change', this._variantChangeHandler);
    };

    _getDefaultVariant() {
      this.variant = this.variantsData.find(v => v.id === +this.getAttribute('current-variant'));
    };

    _checkUnavailable() {
      this.optionsData.map((option, i) => {
        let optionsToCheck = [...this.variant.options];
        option.values.map(optionValue => {
          const value = optionValueName(optionValue);
          optionsToCheck[i] = value;
          const match = this._findVariantByOptions(optionsToCheck);
          this._toggleOption(option.name, value, !match);   
        })
      })
    };

    _toggleOption(name, value, disable) {
      const targetInput = findOptionInput(this, name, value);
      if (!targetInput) return;
      // if (disable) {
      //   targetInput.labels[0].style.outline = '2px solid red';
      //   targetInput.setAttribute('data-unavailable', '');
      //   return;
      // }
      // targetInput.labels[0].style.outline = '';
      // targetInput.removeAttribute('data-unavailable');
      disable
        ? targetInput.setAttribute('data-unavailable', '')
        : targetInput.removeAttribute('data-unavailable');
    };

    _variantChangeHandler(e) {
      this._selectVariantByOption(e.target);
      if (!this.variant) return;
      const { queryURL, currentURL } = updateURLParams({ 'variant': this.variant.id }, this.sectionId);
      if (this.isProductPage) historyPush(currentURL);
      this._checkUnavailable();
      this._fetchPageWithVariant(queryURL, (html) => {
        this.forwardEvent('variantChange', {
          html: html,
          variant: this.variant
        })
      });  
    };

    _selectVariantByOption(target) {
      let valueIndex = this.optionsData.findIndex(option => option.name === target.name);
      if (valueIndex < 0) return;
      if (target.hasAttribute('data-unavailable')) {
        this.variant = this.variantsData.find(variant => variant.options[valueIndex] === target.value);
        if (!this.variant) return;
        this._toogleInputs(target)
      } else {
        let optionsToFind = [...this.variant.options];
        optionsToFind[valueIndex] = target.value;
        this.variant = this._findVariantByOptions(optionsToFind);
        if (!this.variant) {
          this.variant = this.variantsData.find(variant => variant.options[valueIndex] === target.value);
          this._toogleInputs();
          return;
        }
        this._updateSwatchLable(target)
      }
    };

    _toogleInputs() {
      this.variant.options.map((option, i) => {
        const input = findOptionInput(this, this.optionsData[i].name, option);
        if (!input) return;
        input.checked = true;
        this._updateSwatchLable(input)
      }) 
    };

    _findVariantByOptions(options) {
      return this.variantsData.find(variant => isEqual(variant.options, options));
    };

    _updateSwatchLable(swatchInput) {
      const productSwatch = swatchInput.closest('product-variant-swatch');
      if (productSwatch) {
        productSwatch.querySelector('[data-swatch-value]').textContent = swatchInput.value;
        return;
      }
      const cloudsoftGroup = swatchInput.closest('.hm-cloudsoft__option-group');
      const cloudsoftLabel = cloudsoftGroup ? cloudsoftGroup.querySelector('.hm-cloudsoft__option-value') : null;
      if (cloudsoftLabel) {
        cloudsoftLabel.textContent = swatchInput.value;
      }
    };

    _updateURL() {
      if (!this.isProductPage) return;
      const { currentURL } = updateURLParams({ 'variant': this.variant.id });
      historyPush(currentURL);
    };

    _fetchPageWithVariant(url, onResponse) {
      this.forwardEvent('variantLoading');
      return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = parseHTML(responseText)
        onResponse(html);
      });
    };    
  });
})();
